import React, { Component, Fragment } from "react";
import "./OrgChart.css";
import $ from "jquery";
import ReactDomServer from "react-dom/server";
import getLabel from './../../../../../utils/labels'
import checkIcon from "./../../../../../globals/images/option-selected.svg";
import { Group } from "@vx/group";
import { Tree } from "@vx/hierarchy";
import { LinkHorizontal } from "@vx/shape";
import { hierarchy } from "d3-hierarchy";
import { LinearGradient } from "@vx/gradient";

const config = {
	width: 1125,
	height: 600,
	events: false,
	margin: {
		top: 10,
		left: 120,
		right: 40,
		bottom: 80
	}
};

function Node({ node, events }) {
	const width = 200;
	const height = 65;
	let { checkIfOptionPresentInArray, selectedActors, selfActor } = node.data.props;
	let isHighlighted = checkIfOptionPresentInArray(
		selectedActors,
		node.data.id
	);
	let idName = `tutorial-actor-${node.data.index}`;

	let boxMargin = "#e9e9ff";
	if (selfActor === node.data.id) {
		boxMargin = "green";
	}

	if (isHighlighted) {
		boxMargin = "#7f7fce";
	}

	return (
		<Group
			top={node.x}
			left={node.y}
			style={{
				cursor: "pointer"
			}}
			onClick={() => {
				node.data.props.onOptionClick(node.data.id);
			}}
			id={idName}
		>
			<rect
				rx={20}
				ry={20}
				height={height}
				width={width}
				y={-height / 2}
				x={-width / 2}
				fill={isHighlighted ? "#ededff" : "#fbfbff"}
				stroke={boxMargin}
				strokeWidth={1}
			/>
			<g height="100%" width="100%">
				<text
					dy={".33em"}
					fontSize={15}
					fontFamily="Lato"
					textAnchor={"right"}
					style={{
						pointerEvents: "none"
					}}
					fill={"#323232"}
					transform="translate(-20,-10)"
				>
					{node.data.first_name + " " + node.data.last_name}
					{selfActor === node.data.id ? "(You)" : ""}
				</text>
				<text
					dy={".23em"}
					fontSize={11}
					fontFamily="Lato"
					textAnchor={"right"}
					style={{
						pointerEvents: "none"
					}}
					fill={"#"}
					transform="translate(-20,10)"
				>
					{node.data.role
						.split(" ")
						.slice(0, 2)
						.join(" ")}
				</text>
				<text
					dy={".23em"}
					fontSize={11}
					fontFamily="Lato"
					textAnchor={"right"}
					style={{
						pointerEvents: "none"
					}}
					fill={"#"}
					transform="translate(-20,25)"
				>
					{node.data.role
						.split(" ")
						.slice(2)
						.join(" ")}
				</text>
				<image
					href={node.data.gravatar}
					alt="Smiley face"
					height="40"
					width="40"
					transform="translate(-70,-20)"
					clipPath="url(#clipCircle)"
				/>
				{isHighlighted ? (
					<image
						href={checkIcon}
						alt="Smiley face"
						height="20"
						width="20"
						transform="translate(85,-40)"
						clipPath="url(#clipCircle)"
					/>
				) : null}
			</g>
		</Group>
	);
}

function Link({ link }) {
	return (
		<LinkHorizontal
			data={link}
			stroke="#374469"
			strokeWidth="1"
			fill="none"
		/>
	);
}

class App extends Component {
	componentDidMount() {
		// this.$node = $(this.refs.sortable);
		// this.$node.orgchart({
		//     'data': this.props.orgChart[0],
		//     // verticalDepth: 2,s
		//     // depth: 1500,
		//     'depth': 2,
		//     'verticalLevel': 6,
		//     'createNode': ($node, data, key) => {
		//         $node.append(ReactDomServer.renderToStaticMarkup(this.nodeElement(data)));
		//         this.handleClick($node, data);
		//     }
		// });
	}

	componentDidUpdate = () => {
		// this.$node = $(this.refs.sortable);
		// this.$node.empty();
		// this.$node.orgchart({
		//     'data': this.props.orgChart[0],
		//     // verticalDepth: 2,s
		//     // depth: 1500,
		//     'depth': 2,
		//     'verticalLevel': 6,
		//     'createNode': ($node, data, key) => {
		//         $node.append(ReactDomServer.renderToStaticMarkup(this.nodeElement(data)));
		//         this.handleClick($node, data);
		//     }
		// });
	};

	handleClick($node, data) {
		$node.click(event => {
			event.stopPropagation();
			this.props.onOptionClick(data.id);
		});
	}

	nodeElement = data => {
		// let {checkIfOptionPresentInArray, selectedActors} = this.props;
		// let isHighlighted = checkIfOptionPresentInArray(selectedActors, data.id);
		// return (
		//     <div className="node-contents" style={ isHighlighted ? {
		//                                    backgroundColor: '#ededff',
		//                                    border: 'solid 1px #7f7fce'
		//                                } : {} }>
		//       <div className="image">
		//         { isHighlighted ? <img src={ checkIcon } alt="checkicon" /> : null }
		//       </div>
		//       <img className="node-image" src={ data.gravatar } />
		//       <div className='text'>
		//         <div className='name'>
		//           { `${data.first_name} ${data.last_name}` }
		//         </div>
		//         <div>
		//           { data.role }
		//         </div>
		//       </div>
		//     </div>
		// )
	};

	render() {
		let { checkIfOptionPresentInArray, selectedActors } = this.props;
		const actors = this.props.orgChart[0];
		// const raw = actors.map((actor, key) => {
		//     return {
		//         ...actor,
		//         props: this.props
		//     };
		// });
		let index = 0;
		const data = hierarchy(actors);
		data.each(node => {
			node.data.props = this.props;
			node.data.index = index;
			index += 1
		});

		return (
			<div style={{ position: "relative", width: "100%" }}>
				<svg width={config.width} height={config.height}>
					<Tree
						top={config.margin.top}
						left={config.margin.left}
						root={data}
						size={[600, 900]}
						nodeComponent={Node}
						linkComponent={Link}
						separation={(a, b) => {
							return a.parent == b.parent ? 1 : 2;
						}}
					/>
				</svg>
				<div className="chart-type" style={{ top: "10px" }}>
					{getLabel('label_org_chart_text')}
				</div>
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// /src/components/mailThread/compose/actorsHandler/orgChart/OrgChart.js